import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdCheckCircle,
  MdClose,
  MdDelete,
  MdEdit,
} from "react-icons/md";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";
import api from "../../../services/api";
import {
  Card,
  HeaderTitle,
  ViewInput,
  Table,
  Scroll,
  Message,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  Pagination,
  Select,
  DatePicker,
  Switch,
  Spin,
} from "antd";
import { Container } from "./styles";
import { addDays, format, isBefore, startOfDay } from "date-fns";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { useQuery } from "../../../hooks/Location";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

dayjs.extend(weekday);
dayjs.extend(localeData);

const { confirm } = Modal;

const Lembretes = () => {
  const query = useQuery();

  const [leads, setReminders] = useState([]);
  const [leadId, setLeadId] = useState(query.get("lead") || "");
  const [date, setDate] = useState("");
  const [leadsAll, setLeadsAll] = useState([]);
  const [leadsTotal, setRemindersTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [lead, setLead] = useState(query.get("lead") || "");
  const [page, setPage] = useState(0);
  const [id, setId] = useState("");
  const [dateStart, setDateStart] = useState(addDays(new Date(), -30));
  const [dateEnd, setDateEnd] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [all, setAll] = useState(true);
  const [repeat, setRepeat] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    loadReminders(page, all, lead, dateStart, dateEnd, status);
  }, [page, all, lead, dateStart, dateEnd, status]);

  useEffect(() => {
    loadLeadsAll();
  }, []);

  async function loadReminders(page, all, lead, dateStart, dateEnd, status) {
    await api
      .get(
        `/reminders?page=${page}${
          !all ? `&dateStart=${dateStart}&dateEnd=${dateEnd}` : ""
        }${lead ? `&lead_id=${lead}` : ""}${status ? `&status=${status}` : ""}`
      )
      .then((response) => {
        setReminders(response.data.reminders);
        setRemindersTotal(response.data.remindersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function loadLeadsAll() {
    await api
      .get(`/my-leads?all=true`)
      .then((response) => {
        setLeadsAll(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createReminder() {
    setIsLoadingModal(true);
    if (!name || !date || (!id && !leadId)) {
      toast.warn("Preencha o nome, lead e data para salvar lembrete");
    } else {
      if (id) {
        await api
          .put(`/reminder/${id}`, {
            name: name,
            date: date,
            description: description,
          })
          .then((response) => {
            toast.success("Lembrete editado com sucesso");
            loadReminders(page, all, lead, dateStart, dateEnd, status);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      } else {
        await api
          .post(`/reminder/${leadId}`, {
            name: name,
            date: date,
            description: description,
          })
          .then((response) => {
            toast.success("Lembrete criado com sucesso");
            loadReminders(page, all, lead, dateStart, dateEnd, status);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteReminder(reminder) {
    await api
      .delete(`/reminder/${reminder.id}`)
      .then(() => {
        toast.success("Lembrete deletado com sucesso");
        loadReminders(page, all, lead, dateStart, dateEnd, status);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function confirmReminder() {
    setIsLoadingModal(true);
    await api
      .put(`/confirm-reminder/${id}`, {
        name: name,
        description: description,
        repeat: repeat,
        date_repeat: date,
      })
      .then((response) => {
        toast.success("Lembrete confirmado com sucesso");
        loadReminders(page, all, lead, dateStart, dateEnd, status);
        setIsOpenConfirm(false);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  function getDate(date) {
    let fortmatDate = date.split("/");
    return new Date(fortmatDate[2], fortmatDate[1] - 1, fortmatDate[0]);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Lembretes</h1>
        <div>
          <Button
            type="primary"
            style={{
              borderRadius: 50,
            }}
            onClick={() => {
              setDescription("");
              setId("");
              setName("");
              setDate("");
              setIsOpen(true);
            }}
          >
            <MdAdd size="20" color="#fff" />
            <span>Criar Lembrete</span>
          </Button>
        </div>
      </HeaderTitle>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={leadsTotal} separator="." />
      </Card>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ViewInput style={{ width: "100%", maxWidth: 300, marginRight: 15 }}>
          <p>Filtrar por Lead</p>
          <Select
            placeholder="selecionar lead"
            value={lead}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setLead(value);
              setLeadId(value);
              setPage(0);
            }}
          >
            <Select.Option value={""}>Todos Leads</Select.Option>
            {leadsAll.map((item) => {
              return <Select.Option value={item.id}>{item.name}</Select.Option>;
            })}
          </Select>
        </ViewInput>
        <ViewInput style={{ width: "100%", maxWidth: 120, marginRight: 15 }}>
          <p>Status</p>
          <Select
            placeholder="selecionar lead"
            value={status}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setStatus(value);
              setPage(0);
            }}
          >
            <Select.Option value="">Todos</Select.Option>
            <Select.Option value="pendente">Pendente</Select.Option>
            <Select.Option value="concluido">Concluido</Select.Option>
            <Select.Option value="vencido">Vencido</Select.Option>
            <Select.Option value="avencer">À Vencer</Select.Option>
          </Select>
        </ViewInput>
        <ViewInput style={{ width: "100%", maxWidth: 200, marginRight: 15 }}>
          <p>Visualizar</p>
          <Button
            style={{
              color: "#FFF",
              backgroundColor: all ? "#008037" : "#FFF",
              color: !all ? "#008037" : "#FFF",
              width: 80,
              alignSelf: "flex-end",
              marginBottom: 5,
              marginRight: 15,
              borderRadius: 50,
              borderColor: "#008037",
            }}
            onClick={() => {
              setAll(true);
            }}
          >
            Todos
          </Button>
          <Button
            style={{
              color: "#FFF",
              backgroundColor: !all ? "#008037" : "#FFF",
              color: all ? "#008037" : "#FFF",
              width: 105,
              borderRadius: 50,
              alignSelf: "flex-end",
              marginBottom: 5,
              borderColor: "#008037",
            }}
            onClick={() => {
              setAll(false);
            }}
          >
            Por Periodo
          </Button>
        </ViewInput>
        {!all && (
          <ViewInput style={{ width: "100%", maxWidth: 280 }}>
            <p>Alterar Periodo de Cadastro</p>
            <RangePicker
              style={{ width: "100%" }}
              placeholder={["data inicial", "data final"]}
              value={[
                dateStart ? dayjs(dateStart) : "",
                dateEnd ? dayjs(dateEnd) : "",
              ]}
              format={"DD/MM/YYYY"}
              onChange={(value, dateString) => {
                setDateStart(getDate(dateString[0]));
                setDateEnd(getDate(dateString[1]));
                setPage(0);
              }}
              allowClear={false}
            />
          </ViewInput>
        )}
      </div>
      {!isLoading && (
        <>
          {leads?.length ? (
            <>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td>Nome</td>
                      <td>Status</td>
                      <td>Date</td>
                      <td>Lead</td>
                      <td>Descrição</td>
                      <td style={{ width: 80 }}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {leads.map((lead) => (
                      <tr key={lead.id}>
                        <td>{lead.name}</td>
                        <td>
                          {lead.confirm
                            ? "Concluido"
                            : isBefore(
                                new Date(lead.date),
                                startOfDay(new Date())
                              )
                            ? "Vencido"
                            : "Pendente"}
                        </td>
                        <td>
                          {format(new Date(lead.date), "dd/MM/yyyy HH:mm")}
                        </td>
                        <td>{lead.lead.name}</td>
                        <td>{lead.description || "Sem descrição"}</td>
                        <td style={{ width: 120 }}>
                          <div
                            style={{
                              display: "flex",
                              cursor: "pointer",
                              alignItems: "center",
                              justifyContent: "flex-end",
                            }}
                          >
                            {!lead.confirm && (
                              <MdCheckCircle
                                onClick={() => {
                                  setId(lead.id);
                                  setRepeat(false);
                                  setName(lead.name);
                                  setDate("");
                                  setDescription(lead.description);
                                  setIsOpenConfirm(true);
                                }}
                                style={{ cursor: "pointer", marginLeft: 10 }}
                                size={18}
                                color={"#001B22"}
                              />
                            )}
                            {!lead.confirm && (
                              <MdEdit
                                onClick={() => {
                                  setId(lead.id);
                                  setName(lead.name);
                                  setDate(lead.date);
                                  setDescription(lead.description);
                                  setIsOpen(true);
                                }}
                                style={{ cursor: "pointer", marginLeft: 10 }}
                                size={18}
                                color={"#001B22"}
                              />
                            )}
                            <MdDelete
                              onClick={() => {
                                confirm({
                                  okText: "Confirmar",
                                  title: "Deseja excluir o Lembrete?",
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após essa ação, o Lembrete ${lead.name} será excluido.`,
                                  onOk() {
                                    deleteReminder(lead);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{ cursor: "pointer", marginLeft: 6 }}
                              size={18}
                              color={"#001B22"}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scroll>
              <Pagination
                style={{
                  margin: "25px 0",
                  alignSelf: "center",
                }}
                defaultCurrent={page + 1}
                onChange={(page) => {
                  setPage(page - 1);
                }}
                total={leadsTotal}
                pageSize={30}
                showTotal={(total) => `${total} leads`}
              />
            </>
          ) : (
            <Message>Nenhum lembrete encontrado</Message>
          )}
        </>
      )}

      {isLoading && <Spin size="large" style={{ marginTop: 50 }} />}

      <Modal
        title={id ? "Editando lembrete" : "Cadastrando lembrete"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          createReminder();
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <ViewInput>
          <p>Nome*</p>
          <Input
            placeholder="nome"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Data*</p>
          <DatePicker
            placeholder="data"
            style={{ width: "100%" }}
            value={date ? dayjs(date) : ""}
            format={"DD/MM/YYYY"}
            onChange={(value, dateString) => {
              setDate(getDate(dateString));
            }}
            allowClear={false}
          />
        </ViewInput>
        {!id && (
          <ViewInput style={{ width: "100%", marginRight: 15 }}>
            <p>Selecionar Lead*</p>
            <Select
              placeholder="selecionar lead"
              value={leadId || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setLeadId(value);
              }}
            >
              {leadsAll.map((item) => {
                return (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>
        )}
        <ViewInput>
          <p>Descriçao</p>
          <TextArea
            style={{ minHeight: 60 }}
            placeholder="descrição"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </ViewInput>
      </Modal>
      <Modal
        title={"Confirmando lembrete"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpenConfirm}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          confirmReminder();
        }}
        onCancel={() => {
          setIsOpenConfirm(false);
        }}
      >
        <ViewInput>
          <p>Nome*</p>
          <Input
            placeholder="nome"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </ViewInput>
        <ViewInput style={{ textAlign: "start" }}>
          <p>Repetir lembrete*</p>
          <Switch checked={repeat} onChange={(event) => setRepeat(!repeat)} />
        </ViewInput>
        {repeat && (
          <ViewInput>
            <p>Data*</p>
            <DatePicker
              placeholder="data"
              style={{ width: "100%" }}
              value={date ? dayjs(date) : ""}
              format={"DD/MM/YYYY"}
              onChange={(value, dateString) => {
                setDate(getDate(dateString));
              }}
              allowClear={false}
            />
          </ViewInput>
        )}
        {!id && (
          <ViewInput style={{ width: "100%", marginRight: 15 }}>
            <p>Selecionar Lead*</p>
            <Select
              placeholder="selecionar lead"
              value={leadId || null}
              showSearch
              optionFilterProp="children"
              style={{ width: "100%", textAlign: "left" }}
              onChange={(value) => {
                setLeadId(value);
              }}
            >
              {leadsAll.map((item) => {
                return (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                );
              })}
            </Select>
          </ViewInput>
        )}
        <ViewInput>
          <p>Descriçao</p>
          <TextArea
            style={{ minHeight: 60 }}
            placeholder="descrição"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </ViewInput>
      </Modal>
    </Container>
  );
};

export default Lembretes;
